/** Canonical MaidEaze listing: play.google.com/store/apps/details?id=com.dawnspark.maideaze */
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.dawnspark.maideaze&hl=en";

/** Use CMS/Firebase URL only when it is a Play Store listing URL; otherwise PLAY_STORE_URL. */
export function resolvePlayStoreUrl(url) {
  if (typeof url !== "string") return PLAY_STORE_URL;
  const u = url.trim();
  if (!u || u === "#") return PLAY_STORE_URL;
  if (u.includes("play.google.com") && u.includes("/store")) return u;
  return PLAY_STORE_URL;
}
